import React from 'react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="w-full bg-ink-soft px-4 py-20" data-id="element-108">
      <Reveal className="mx-auto max-w-2xl rounded-3xl border border-ink-border bg-ink-card p-8 text-center sm:p-12" data-id="element-109">
        <p className="text-sm font-bold uppercase tracking-widest text-grass" data-id="element-110">
          ✔ Zéro risque
        </p>
        <div className="mt-4 text-5xl" data-id="element-111">🛡️</div>
        <h2 className="mt-4 font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-112">
          Garantie 7 Jours
        </h2>
        <p className="mt-5 text-white/70" data-id="element-113">
          Ouvrez tout. Consultez chaque protocole. Utilisez les supports.
        </p>
        <p className="mt-4 text-white/70" data-id="element-114">
          Testez Le Protocole Clinique sans risque. Si vous n'êtes pas
          entièrement satisfait, nous vous remboursons 100%, sans questions.
        </p>
        <p className="mt-4 font-bold text-white" data-id="element-115">Sans questions.</p>
        <p className="mt-6 inline-block rounded-full bg-grass/15 px-4 py-2 text-sm font-semibold text-grass" data-id="element-116">
          Taux de remboursement inférieur à 1%
        </p>
      </Reveal>
    </section>;
}